import React from 'react';
import PropTypes from 'prop-types';

import './checkout-title.scss';


export default function CheckoutTitle({ children }) {
    return (
        <p styleName="ny__checkout__title">
            {children}
        </p>
    );
}

CheckoutTitle.propTypes = {
};
